export default __webpack_public_path__ + "static/media/templatesIcon.4f6ea53b.svg";